<template>
  <el-dialog v-model="visible" title="保存绘图" width="31.25rem">
    <el-form label-width="6.25rem">
      <el-form-item label="保存方式">
        <el-radio-group v-model="saveType">
          <el-radio label="new">新建画布</el-radio>
          <el-radio label="existing">已有画布</el-radio>
        </el-radio-group>
      </el-form-item>
      
      <el-form-item label="画布名称" v-if="saveType === 'new'">
        <el-input v-model="newMapName" placeholder="请输入画布名称" />
      </el-form-item>
      
      <el-form-item label="选择画布" v-if="saveType === 'existing'">
        <el-select v-model="selectedMapId" placeholder="请选择画布" style="width: 100%">
          <el-option
            v-for="map in existingMaps"
            :key="map.id"
            :label="map.name"
            :value="map.id"
          />
        </el-select>
      </el-form-item>
    </el-form>
    
    <template #footer>
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="handleConfirm">确定</el-button>
    </template>
  </el-dialog>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { queryFavorites } from '@/api/MyMap';

const emit = defineEmits(['confirm']);

const visible = ref(false);
const saveType = ref('new');
const newMapName = ref('');
const selectedMapId = ref('');
const existingMaps = ref([]);

// 打开对话框
const open = async () => {
  visible.value = true;
  saveType.value = 'new';
  newMapName.value = '';
  selectedMapId.value = '';
  
  // 加载已有画布列表
  try {
    const res = await queryFavorites({});
    if (res.data.code === 1004) {
      existingMaps.value = res.data.dataList.map(item => ({
        id: item.id,
        name: item.name
      }));
    }
  } catch (error) {
    console.error('加载画布列表失败:', error);
  }
};

// 确认保存
const handleConfirm = () => {
  if (saveType.value === 'new' && !newMapName.value.trim()) {
    message('请输入画布名称', 0);
    return;
  }
  
  if (saveType.value === 'existing' && !selectedMapId.value) {
    message('请选择画布', 0);
    return;
  }
  
  emit('confirm', {
    type: saveType.value,
    name: saveType.value === 'new' ? newMapName.value.trim() : '',
    id: saveType.value === 'existing' ? selectedMapId.value : ''
  });
  
  visible.value = false;
};

defineExpose({
  open
});
</script>